module.exports = __webpack_public_path__ + "img/bg_video2.4b554429.jpg";